import React, { useEffect } from 'react';
import cs from 'classnames';
import { useLocation } from 'react-router-dom';
import { Dropdown, Button, MenuProps } from 'antd';
import { setPlatform } from '@tencentcloud/chat-uikit-react';
import { DownOutlined } from '@ant-design/icons';
import { reportEvent, REPORT_KEY } from '@/utils/aegis';

import './ControllerHeader.scss';

interface IControllerHeaderProps {
  env: string;
  language: string;
  theme: string;
  setEnv: React.Dispatch<React.SetStateAction<'web' | 'mobile'>>;
  setLanguage: React.Dispatch<React.SetStateAction<string>>;
  setTheme: React.Dispatch<React.SetStateAction<string>>;
}

const languageItems: MenuProps['items'] = [
  {
    key: 'en-US',
    label: 'English',
  }, {
    key: 'ja-JP',
    label: '日本語',
  }, {
    key: 'ko-KR',
    label: '한국어',
  }, {
    key: 'zh-CN',
    label: '中文简体',
  }, {
    key: 'zh-TW',
    label: '中文繁體',
  },
];

const themeItems: MenuProps['items'] = [{
  key: 'light',
  label: 'light',
}, {
  key: 'dark',
  label: 'dark',
}];

function ControllerHeader(props: IControllerHeaderProps) {
  const {
    env,
    language,
    theme,
    setEnv,
    setLanguage,
    setTheme,
  } = props;

  const { pathname } = useLocation();

  function onSwitchEnv(newEnv: 'web' | 'mobile') {
    setEnv(newEnv);
    setPlatform(newEnv === 'mobile' ? 'h5' : 'pc');
    reportEvent({ actionKey: REPORT_KEY[`SWITCH_TO_${env === 'mobile' ? 'MOBILE' : 'WEB'}`], fromPath: pathname });
  }

  function getCurrentLanguageLabel() {
    const languageItem = languageItems?.find((item) => {
      if (!item) {
        throw new Error('language item is empty');
      }
      return item.key === language;
    });

    return (languageItem as { key: string; label: string }).label;
  }

  const onLanguageDropdownItemClick: MenuProps['onClick'] = ({ key }) => {
    setLanguage(key);
  };

  const onThemeItemClick: MenuProps['onClick'] = ({ key }) => {
    setTheme(key);
  };

  return (
    <div className="controller-header">
      <div className="env-switch-container">
        <div
          className={cs('switch-button', {
            'switch-button-active': env === 'web',
          })}
          onClick={() => onSwitchEnv('web')}
        >
          WEB
        </div>
        <div
          className={cs('switch-button', {
            'switch-button-active': env === 'mobile',
          })}
          onClick={() => onSwitchEnv('mobile')}
        >
          MOBILE
        </div>
      </div>
      <div className="other-controller-options">
        <Dropdown className="dropdown" menu={{ items: languageItems, onClick: onLanguageDropdownItemClick }}>
          <Button>
            {getCurrentLanguageLabel()}
            <DownOutlined />
          </Button>
        </Dropdown>
        <Dropdown className="dropdown" menu={{ items: themeItems, onClick: onThemeItemClick }}>
          <Button>
            {theme}
            <DownOutlined />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}

export default ControllerHeader;
